import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeader } from './ui/SectionHeader';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoFor() {
  const isFor = ['Professionals 35+ who value their time and want a "frictionless" travel experience.', 'Travelers tired of being treated like an outsider and wanting a deeper, more authentic connection to Italy.', 'Anyone who wants to feel like the most confident person in the room, from Milan to Sicily.'];
  const isNotFor = ['Budget backpackers looking for the cheapest hostels.', 'Students who want to learn academic Italian grammar for a degree.', 'Travelers who prefer staying inside the "tourist bubble" and eating at chain restaurants.'];
  return <section className="py-24 bg-ivory-100 border-y border-gold/10" data-id="element-173">
      <div className="max-w-5xl mx-auto px-6" data-id="element-174">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-175">
          {/* Who this is for */}
          <div data-id="element-176">
            <SectionHeader eyebrow="The Audience" title="Who This Is For" data-id="element-177" />
            <div className="space-y-6 mt-8" data-id="element-178">
              {isFor.map((text, i) => <FadeIn key={i} delay={0.1 * i} direction="left" data-id="element-179">
                  <div className="flex items-start gap-4" data-id="element-180">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-emerald-900/10 flex items-center justify-center" data-id="element-181">
                      <CheckIcon className="w-4 h-4 text-emerald-900" strokeWidth={2} data-id="element-182" />
                    </div>
                    <p className="text-charcoal/80 font-sans font-light leading-relaxed" data-id="element-183">
                      {text}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          {/* Who this is not for */}
          <div data-id="element-184">
            <SectionHeader eyebrow="The Exclusion" title="Who This Is Not For" data-id="element-185" />
            <div className="space-y-6 mt-8" data-id="element-186">
              {isNotFor.map((text, i) => <FadeIn key={i} delay={0.1 * i} direction="right" data-id="element-187">
                  <div className="flex items-start gap-4 opacity-70" data-id="element-188">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-red-900/5 flex items-center justify-center" data-id="element-189">
                      <XIcon className="w-4 h-4 text-red-900/60" strokeWidth={2} data-id="element-190" />
                    </div>
                    <p className="text-charcoal/70 font-sans font-light leading-relaxed" data-id="element-191">
                      {text}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}